import { createWebSocketStore } from 'src/components/#services/helpers';
export const getNftByFilter = createWebSocketStore({
    auth: false,
    requestTemplate: {
        method: 'marketEndpoints_getByFilter',
        agent: 'market-place',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const getNftHistory = createWebSocketStore({
    auth: false,
    requestTemplate: {
        method: 'marketPlace_getItemHistory',
        agent: 'market-place',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const getSimilar = createWebSocketStore({
    auth: false,
    requestTemplate: {
        method: 'marketEndpoints_getSimilar',
        agent: 'market-place',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const buyNft = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'marketPlace_initBuyingItem',
        agent: 'market-place',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const marketplaceTransactions = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'journal_getMarketplaceTransactions',
        agent: 'market-place',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const isConfirmedAction = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'marketPlace_isConfirmedAction',
        agent: 'market-place',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const confirmAction = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'marketPlace_confirmAction',
        agent: 'market-place',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
